const Hide = ({ show, children }) => (
  <div className={`display-${show ? "unset" : "none"}`}>{children}</div>
);

export default Hide;
